var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"iframe-welcome",attrs:{"id":"iframe-welcome","src":"https://www.cordial.fr/grammaire/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }